import { Button, ButtonProps } from '@wix/design-system';
import React from 'react';
import { DisabledTooltip } from '../DisabledTooltip';
import { MultiBulkActionSubItemPrivate } from './MultiBulkActionProps';
import { useToolbarCollectionContext } from '../ToolbarCollectionContext';
import { MultiBulkActionToolbarState } from '../MultiBulkActionToolbar';
import { FiltersMap } from '@wix/bex-core';

export interface MultiBulkActionButtonProps<T, F extends FiltersMap> {
  actionItem: MultiBulkActionSubItemPrivate;
  state: MultiBulkActionToolbarState<T, F>;
  suffixIcon?: ButtonProps['suffixIcon'];
}

export function MultiBulkActionButton<T, F extends FiltersMap>(
  props: MultiBulkActionButtonProps<T, F>,
) {
  const { actionItem, state, suffixIcon } = props;
  const {
    tooltipText,
    prefixIcon,
    text,
    onClick,
    dataHook = 'bulk-action-button',
    disabled,
    biName,
    biIndex,
  } = actionItem;

  const { toolbarBIReporter } = useToolbarCollectionContext();

  return (
    <DisabledTooltip content={tooltipText} dataHook={`${dataHook}-tooltip`}>
      <Button
        skin="standard"
        priority="secondary"
        size="small"
        prefixIcon={prefixIcon}
        onClick={() => {
          toolbarBIReporter.ctaClicked({
            location: 'multiBulkActionToolbar',
            ctaName: biName ?? '',
            ctaIndex: biIndex + 1,
            moreActionsIndex: 0,
            numCtas:
              state.primaryActionItems.length +
              state.secondaryActionItems.length,
          });
          onClick?.();
        }}
        dataHook={dataHook}
        disabled={disabled}
        suffixIcon={suffixIcon}
      >
        {text}
      </Button>
    </DisabledTooltip>
  );
}
